// extracted by mini-css-extract-plugin
module.exports = {"multiselect":"styles-module__multiselect___3Tk4n"};